<script>
    import EditableSelectSingle from "./EditableSelectSingle";
    import EditableSelectMultiple from "./EditableSelectMultiple";

    export default {
        components: {
            'editable-select-single': EditableSelectSingle,
            'editable-select-multiple': EditableSelectMultiple
        },
        props: {
            multiple: Boolean,
            headline: String,
            selected: Array | Object,
            selector: String,
            options: Array | Object,
            additional: Array | null,
            ajaxUpdateUrl: String | null,
            ajaxUpdateProperty: String | null,
        },
        data() {
            return {
                selectedMutable: this.selected,
            }
        },
        computed: {
            isEmpty() {
                return this.selectedMutable.length === 0;
            }
        },
        methods: {
            updateSingleValue(value) {
                if (!this.ajaxUpdateUrl && !this.ajaxUpdateProperty) {
                    this.$emit('update', value);
                }
                let obj = {'updateMode': 'single'};
                obj[this.ajaxUpdateProperty] = value;

                axios.put(this.ajaxUpdateUrl, obj).then((response) => {
                    if (response.data.success) {
                        toastr.success('Successfully saved')
                    }
                });
            },
            updateMultipleValues(values) {
                if (!this.ajaxUpdateUrl && !this.ajaxUpdateProperty) {
                    this.$emit('update', value);
                }
                let obj = {'updateMode': 'multiple'};
                if (this.additional) {
                    obj[this.ajaxUpdateProperty] = _.reduce(values, (obj, val) => {
                        let properties = {};
                        _.each(this.additional, (prop) => {
                            properties[prop] = val[prop];
                        });
                        obj[val.id] = properties;
                        return obj;
                    }, {});
                } else {
                    obj[this.ajaxUpdateProperty] = _.map(values, 'id');
                }
                axios.put(this.ajaxUpdateUrl, obj).then((response) => {
                    if (response.data.success) {
                        this.selectedMutable = values;
                        toastr.success('Successfully saved')
                    } else {
                        toastr.error('Something went wrong')
                    }
                });
            }
        }
    }
</script>

<template>
    <div>
        <editable-select-multiple @update="updateMultipleValues" v-if="multiple"/>
        <editable-select-single @update="updateSingleValue" v-else/>
    </div>
</template>
